/**
 * Created by alexandreroitman on 26/05/2016.
 */
define([
    'lodash',
    'reactDOM',
    'santa-components',
    'textCommon',
    'skins',
    'radioGroup/skins/skins.json',
    'componentsCore'
], function (
    _,
    ReactDOM,
    santaComponents,
    textCommon,
    skinsPackage,
    skinsJson,
    componentsCore
) {
    'use strict';

    const radioButtonSkinPart = 'radioButton';
    const RADIO_REF_PREFIX = 'radio';
    const FIRST_RADIO_INPUT_PATH = ['radio0', 'refs', 'radio-input'];
    const CHILD_BUTTON_MIN_WIDTH = 60;

    const getPublicState = function (state) {
        return santaComponents.mixins.validatableWithSyncMixin.getPublicState(state);
    };

    const isVerticalLayout = props => props.compProp.layout === 'vertical';
    const labelUtils = textCommon.labelUtils;
    const radioGroup = {
        displayName: 'RadioGroup',

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            shouldResetComponent: santaComponents.santaTypesDefinitions.RenderFlags.shouldResetComponent,
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView,
            isResponsive: santaComponents.santaTypesDefinitions.RendererModel.isResponsive
        },

        mixins: [
            componentsCore.mixins.skinBasedComp,
            santaComponents.mixins.runTimeCompData,
            textCommon.textScaleMixin,
            santaComponents.mixins.inputFocusMixin,
            santaComponents.mixins.validatableWithSyncMixin.validatableWithSync, santaComponents.mixins.compStateMixin(getPublicState),
            componentsCore.mixins.createChildComponentMixin
        ],

        statics: {
            compSpecificIsDomOnlyOverride() {
                return false;
            },
            behaviors: _.assign({},
                santaComponents.mixins.inputFocusMixin.INPUT_FOCUS_BEHAVIORS,
                santaComponents.mixins.validatableWithSyncMixin.VALIDATABLE_WITH_SYNC_BEHAVIORS
            )
        },

        getInitialState() {
            this.shouldResetComponent = this.props.shouldResetComponent;
            return _.assign(getPublicState(), {
                $mobile: this.props.isMobileView ? 'mobile' : 'desktop'
            });
        },

        componentWillReceiveProps(nextProps) {
            if (nextProps.shouldResetComponent && nextProps.shouldResetComponent !== this.shouldResetComponent) {
                this.hideValidityIndication();
            }
            this.shouldResetComponent = nextProps.shouldResetComponent;
        },

        getFirstRadioInputDOMNode() {
            const inputComponent = _.get(this.refs, FIRST_RADIO_INPUT_PATH);

            return ReactDOM.findDOMNode(inputComponent);
        },
        getAllRadioInputsDOMNodes() {
            return _(this.refs)
                .filter(function (ref, refKey) {
                    return refKey.indexOf(RADIO_REF_PREFIX) === 0;
                })
                .values()
                .map(function (radioComp) {
                    return _.get(radioComp, ['refs', 'radio-input']);
                })
                .value();
        },
        focus() {
            const selectedRadioInput = _.find(this.getAllRadioInputsDOMNodes(), 'checked');

            const radioInputToFocus = selectedRadioInput || this.getFirstRadioInputDOMNode();

            radioInputToFocus.focus();
        },
        blur() {
            _.forEach(this.getAllRadioInputsDOMNodes(), function (radioInput) {
                radioInput.blur();
            });
        },

        setRadioSelected(item, index, event) {
            if (this.props.compData.value === item.value) {
                return;
            }
            this.updateData({value: item.value});
            this.handleAction('change', event);
        },

        createChildren() {
            return _.map(this.props.compData.options, this.createChildRadioButton);
        },

        createChildRadioButton(item, index) {
            const numOfOptions = this.props.compData.options.length;
            const lastChild = index === numOfOptions - 1;

            const extraProps = {
                id: `${this.props.id}radio${index}`,
                ref: RADIO_REF_PREFIX + index,
                text: this.props.compData.options[index].label,
                groupName: this.props.id,
                key: `radio${index}${item.label}`,
                onChange: this.setRadioSelected.bind(this, item, index),
                buttonSize: this.props.compProp.buttonSize,
                previewState: this.getComponentPreviewState(),
                invalid: !this.isValid(),
                validityIndication: this.shouldShowValidityIndication(),
                'data-error': !this.isValid(),
                textStyle: this.getFontSize('fnt'),
                numOfOptions,
                layout: this.props.compProp.layout,
                style: {}
            };

            if (!lastChild) {
                if (isVerticalLayout(this.props)) {
                    extraProps.marginBottom = this.props.compProp.buttonsMargin;
                } else {
                    extraProps.marginRight = this.props.compProp.buttonsMargin;
                }
            }

            const valueFromData = this.props.compData.value;
            if (valueFromData === item.value) {
                extraProps.checked = true;
            } else {
                extraProps.checked = false;
            }

            return this.createChildComponent(item, 'wysiwyg.viewer.components.inputs.RadioButton', radioButtonSkinPart, extraProps);
        },

        getLabelStyle() {
            const {alignment, labelMargin} = this.props.compProp;
            const isLabelExist = this.props.compData.label;

            return _.merge({},
                this.getFontSize('fnt2'),
                {
                    display: isLabelExist ? 'inline-block' : 'none',
                    marginBottom: labelMargin,
                    textAlign: alignment,
                    direction: alignment === 'right' ? 'rtl' : 'ltr'
                });
        },

        getSkinProperties() {
            const {compData, compProp, compTheme, isResponsive} = this.props;
            const rootClassSet = {'required': labelUtils.showRequired(compData, compProp, compTheme)};

            rootClassSet[`${this.props.compProp.layout}-axis`] = true;
            const radioButtons = this.createChildren();
            const style = isResponsive ? {} : {
                height: '',
                minWidth: isVerticalLayout(this.props) ? CHILD_BUTTON_MIN_WIDTH : radioButtons.length * CHILD_BUTTON_MIN_WIDTH
            };

            return {
                '': {
                    style,
                    className: this.classSet(rootClassSet)
                },
                items: {
                    children: radioButtons
                },
                label: {
                    children: this.props.compData.label,
                    style: this.getLabelStyle()
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.inputs.RadioGroup', radioGroup);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return radioGroup;
});
